export const HEADER_HEIGHT = 50;
export const LAYOUT_SIDE_INDENT_DESKTOP = 3.75;
export const LAYOUT_SIDE_INDENT_MOBILE = 2.5;
export const SIDEBAR_WIDTH_RATE_LG_SCREEN = 2.6;
export const MAIN_CONTENT_WIDTH_RATE_LG_SCREEN = 9.4;
